export default __webpack_public_path__ + "static/media/React-Logo.ae626225.svg";